import { render, staticRenderFns } from "./archivesTree.vue?vue&type=template&id=1b58d91e&scoped=true&"
import script from "./archivesTree.vue?vue&type=script&lang=js&"
export * from "./archivesTree.vue?vue&type=script&lang=js&"
import style0 from "./archivesTree.vue?vue&type=style&index=0&id=1b58d91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b58d91e",
  null
  
)

export default component.exports